// extracted by mini-css-extract-plugin
module.exports = {"notification":"CustomForm_notification__x07Xk","notification__content":"CustomForm_notification__content__FcqaZ"};